import React from 'react'
import ExternalFrame from './myScripts/ExternalFrame'
import "./myStyles/style.scss"

function App() {
  return (
    <>
      <ExternalFrame />
    </>
  )
}

export default App